import React, { useState } from 'react';
import { Button, Card, notification } from 'antd';
import { GoogleOutlined } from '@ant-design/icons';
import { observer, inject } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { signInWithPopup } from 'firebase/auth';
import { auth as firebaseAuth, googleProvider } from '../../configs/firebase';
import { loginWithGoogle } from '../../api/authApi';

const LoginComponent = ({ userStore, tokenStore, user_id, permissions }) => {
  const [loading, setLoading] = useState(false);
  const { push } = useHistory();

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const result = await signInWithPopup(firebaseAuth, googleProvider);
      const idToken = await result.user.getIdToken();

      const { data } = await loginWithGoogle(idToken);

      if (!data?.data?.user) {
        throw new Error(data?.msg || 'Invalid response from server');
      }

      user_id.value = data.data.user.userId;
      userStore.value = data.data.user;
      tokenStore.value = data.data.token;
      permissions.value = data.data.permissions;
      push('/');
    } catch (err) {
      const status = err?.response?.status;
      let description = 'Authentication failed. Please try again.';

      if (err?.code === 'auth/popup-closed-by-user') {
        description = 'Login cancelled. Please try again.';
      } else if (err?.code === 'auth/network-request-failed') {
        description = 'Network error. Please check your connection.';
      } else if (status === 401) {
        description = 'No B2B account is linked to this Google email. Contact your administrator.';
      } else if (err?.response?.data?.msg) {
        description = err.response.data.msg;
      }

      notification.error({
        placement: 'bottomRight',
        message: "Can't login",
        description,
      });
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      title="Login to continue"
      style={{
        width: 500,
        padding: '50px 20px 20px',
        backgroundColor: '#fff',
        textAlign: 'center',
      }}
    >
      <p style={{ color: 'rgba(0,0,0,0.6)', marginBottom: 32, fontSize: 16 }}>
        Sign in with your Google account
      </p>

      <Button
        block
        type="primary"
        size="large"
        icon={<GoogleOutlined />}
        loading={loading}
        onClick={handleGoogleLogin}
        style={{
          backgroundColor: '#1890ff',
          border: 'none',
          height: 50,
          fontWeight: 600,
        }}
      >
        Sign in with Google
      </Button>

      <p style={{ color: 'rgba(0,0,0,0.45)', fontSize: 12, marginTop: 24 }}>
        Only authorized Lezzoo B2B accounts can access this system
      </p>
    </Card>
  );
};

export default inject('userStore', 'tokenStore', 'user_id', 'permissions')(observer(LoginComponent));
